"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RewardShopBanner = void 0;
var _mui = require("@ori-ui/mui");
var _checkoutUi = require("@ori/checkout-ui");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
const RewardShopBanner = ({
  'data-testid': testId,
  rewardShopBanner: {
    daysToExpire,
    expiringPoints,
    isExpiring,
    remainingPoints
  }
}) => {
  const {
    rewardsShopLink
  } = (0, _contexts.useCheckoutBasket)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();

  // button with data-testid={`${testId}-link`} is removed
  // link is now on entire element

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkoutUi.ActionBanner, {
    "data-testid": testId,
    iconName: "PickupFilled",
    href: rewardsShopLink,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
        children: formatMessage('youStillHave0pointsLeft', {
          0: remainingPoints
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), isExpiring ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: formatMessage('expiringInFewDays', {
            0: expiringPoints,
            1: daysToExpire
          })
        }), "\xA0\xA0"]
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: formatMessage('goToRewardsShop')
      })]
    })
  });
};
exports.RewardShopBanner = RewardShopBanner;